import { createApiService } from './createApiService'

export const authAPI = createApiService({
  reducerPath: 'authAPI',
  tagTypes: ['Auth'],
  endpoints: (build: any) => ({
    login: build.mutation({
      query: ({ email, password }: { email: string; password: string }) => ({
        url: `/auth/login`,
        method: 'POST',
        body: {user: { email: email, password: password}},
      }),
    }),
    refreshToken: build.mutation({
      query: ({ refresh_token }: { refresh_token: string }) => ({
        url: `/auth/refresh`,
        method: 'POST',
        body: { refresh_token },
      }),
    }),
    validateToken: build.query({
      query: () => ({
        url: `/auth/validate`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useLoginMutation, useRefreshTokenMutation, useValidateTokenQuery } = authAPI
